import React, { useState, useEffect } from 'react';
import { Card, Modal, ModalHeader, ModalBody, Badge, CardHeader, Button, CardBody } from 'reactstrap';
import IntlMessages from '../../helpers/IntlMessages';
import classnames from 'classnames';
import { Separator } from '../../components/common/CustomBootstrap';
import { END_POINT } from '../../constants/defaultValues';
import { AddCommaNumber } from '../../helpers/Utils';
import PerfectScrollbar from 'react-perfect-scrollbar';

const getWidth = () =>
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

function useCurrentWitdh() {
    // save current window width in the state object
    let [width, setWidth] = useState(getWidth());

    // in this case useEffect will execute only once because
    // it does not have any dependencies.
    useEffect(() => {
        // timeoutId for debounce mechanism
        let timeoutId = null;
        const resizeListener = () => {
            // prevent execution of previous setTimeout
            clearTimeout(timeoutId);
            // change width from the state object after 150 milliseconds
            timeoutId = setTimeout(() => setWidth(getWidth()), 150);
        };
        // set resize listener
        window.addEventListener('resize', resizeListener);

        // clean up function
        return () => {
            // remove resize listener
            window.removeEventListener('resize', resizeListener);
        };
    }, []);

    return width;
}

const ProvisionalInvoice = ({
    isOpen,
    toggle,
    dataProvisionalInvoice,
    reOrders,
    onCancelProvisionalInvoice
}) => {
    let width = useCurrentWitdh();
    const isMobile = width <= 980;
    // console.log('dataProvisionalInvoice', dataProvisionalInvoice);

    return (
            <Modal
                isOpen={isOpen}
                toggle={toggle}
                className={classnames('table-modal cursor-pointer', {
                    'table-bill-desktop': !isMobile,
                })}
                wrapClassName='modal-right'
                backdrop={true}
            >
                <ModalHeader toggle={toggle}>Hóa đơn tạm tính</ModalHeader>
                <ModalBody>
                    <div className='scroll provisional-list'>
                        {dataProvisionalInvoice && dataProvisionalInvoice.length > 0 ?
                            <PerfectScrollbar
                                options={{
                                    suppressScrollX: true,
                                    wheelPropagation: true,
                                }}
                            >
                                {dataProvisionalInvoice.map((data, index) => (
                                    <Card className='mb-3'>
                                        <CardHeader className='p-0 d-flex justify-content-between align-items-center'>
                                            <h5 className='p-3 mb-0 text-center'>
                                                <IntlMessages id='dashboards.counter' />
                                            </h5>
                                            <div className='mr-2'>
                                                <Button className='mr-2 btn-sm px-5' color="primary" onClick={() => reOrders(index)}>ĐẶT LẠI</Button>
                                                <Button className='btn-sm px-4' color="danger" onClick={() => onCancelProvisionalInvoice(index)}>HỦY</Button>
                                            </div>
                                        </CardHeader>
                                        <Separator className='mb-3' />
                                        {data?.orders?.map(order => 
                                            <div
                                                className='d-flex flex-row'
                                                key={order?.id}
                                            >
                                                <div className='d-block position-relative'>
                                                <img
                                                    onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = 'https://placehold.co/320x240';
                                                    }}
                                                    src={
                                                    order?.product?.image?.indexOf('http') >= 0
                                                        ? order?.product?.image
                                                        : END_POINT + '/public/' + order?.product?.image
                                                    }
                                                    alt={order?.product?.name}
                                                    className='list-thumbnail border-0 m-2'
                                                />
                                                </div>
                                                <div className='card-body-custom d-flex flex-column min-width-zero p-05rem'>
                                                    <div className='d-flex justify-content-between'>
                                                        <span className='list-item-heading'>
                                                            {order?.product?.name}
                                                        </span>
                                                        <span>
                                                            <Badge color='primary'>
                                                            {AddCommaNumber(order?.price)} đ
                                                            </Badge>
                                                        </span>
                                                    </div>
                                                    <div className='text-primary text-small font-weight-medium d-sm-block'>
                                                        {order?.date} - {order?.time}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </Card>
                                
                                ))}
                            </PerfectScrollbar> : 
                            <Card>
                                <CardBody className='text-center'>
                                    <p className='text-muted mb-0'>Chưa có hóa đơn tạm tính nào được lưu!</p>
                                </CardBody>
                            </Card>
                        }
                    </div>
                </ModalBody>
            </Modal>
    );
};
export default ProvisionalInvoice;
